import React from 'react'
import Link from 'gatsby-link'
import profilePic from './fiore.jpg'


class Bio extends React.Component {
  render() {
    return (
     
      <div className="card">
      <div className="card-content">
        <div className="media">
          <div className="media-left">
            <figure className="image is-48x48">
            <img
              src={profilePic}
              alt={`Fiore Basile`}
            />
            </figure>
          </div>
          <div className="media-content">
          <p className="title is-4">Fiore Basile</p>
            Creative, coder, digital fabrication expert and instructor
            living in Pisa, Italy and around the globe.{' '}
            <Link to="/about">More about me</Link>
          </div>
        </div>
    
      </div>
      </div>

    )
  }
}

export default Bio



// WEBPACK FOOTER //
// ./src/components/Bio.js